<template>
  <!-- 兼容房间榜单&个人榜单 收敛逻辑 -->
  <q-section v-bind="$attrs" p="relative">
    <ui-tabs
      :tabs="[uiMeta.images.rankTab1, uiMeta.images.rankTab2]"
      :active="rankType"
      @update:model-value="handleRankType"
      v-bind="uiMeta.layout.tabConfig" />
    <q-section
      :bg-i="uiMeta.images[`textBg${rankType + 1}`]"
      :key="`textBg${rankType + 1}`"
      v-bind="uiMeta.layout.textConfig"></q-section>
    <q-section :bg-i="uiMeta.images.rankDetailBg" v-bind="uiMeta.layout.rankDetailConfig" @click="toRule"></q-section>
    <Top3 v-if="!isRoomRank" :top3="top3" v-bind="uiMeta.layout.top3WrapperConfig" @avatar-click="handleAvatarClick" />
    <RankList
      :listother="listother"
      v-bind="uiMeta.layout.otherListWrapperConfig"
      :isRoomRank="isRoomRank"
      @avatar-click="handleAvatarClick"
      @room-click="handleRoomClick" />
    <RankMine
      v-if="!isRoomRank"
      :mineRank="mine"
      v-bind="uiMeta.layout.mineWrapperConfig"
      @click="handleClick"
      @avatar-click="handleAvatarClick" />
  </q-section>
</template>

<script setup lang="ts">
import { useRank } from './use-rank'
import { useRouter, useRoute } from 'vue-router'
import Top3 from './top3.vue'
import RankList from './rank-list.vue'
import RankMine from './rank-mine.vue'
import { watch } from 'vue'
import { setActivityBuffCards } from '@/state/activity-state'

const props = defineProps({
  uiMeta: {
    type: Object,
    default: () => {},
  },
  buffSource: {
    type: String,
    default: '',
  },
})

const {
  mine,
  top3,
  listother,
  buffCards,
  rankType,
  handleRankType,
  handleClick,
  handleAvatarClick,
  isRoomRank,
  handleRoomClick,
} = useRank(props.uiMeta, {})

console.log('buffCards-------_>', buffCards.value)

const router = useRouter()
const route = useRoute()

watch(
  buffCards,
  next => {
    if (!props.buffSource) {
      return
    }
    const activityCode = (route.meta?.activity_code as any)?.toString?.() || ''
    if (!activityCode) {
      return
    }
    setActivityBuffCards(activityCode, props.buffSource as any, next)
  },
  { immediate: true }
)

const toRule = () => {
  router.push({
    path: props.uiMeta.config.detailRouter,
    query: {
      target: props.uiMeta.config.targetRuleTab,
    },
  })
}
</script>

<style scoped lang="scss"></style>
